import React, { useEffect, useState } from "react";
import dummyUser from "../../../assets/images/dummy/dummy-user.png";
import { getAsset } from "../../../helpers/helper";

const RegisteredUserAvatar = ({ user }) => {
  const imageSource = Array.isArray(user?.imageUrl)
    ? user.imageUrl.find(Boolean)
    : user?.imageUrl;
  const imageUrl = imageSource ? getAsset(imageSource) : dummyUser;
  const [imageFailed, setImageFailed] = useState(false);

  useEffect(() => {
    setImageFailed(false);
  }, [imageUrl]);

  return (
    <img
      className="shop-invite-result-avatar"
      src={imageFailed ? dummyUser : imageUrl}
      alt=""
      aria-hidden="true"
      onError={() => setImageFailed(true)}
    />
  );
};

export default RegisteredUserAvatar;
